export const BREAKPOINT_WIDTH = 768
export const BREAKPOINT_XXS = 480
export const BREAKPOINT_XS = BREAKPOINT_WIDTH - 1
export const BREAKPOINT_SM = 1023
export const BREAKPOINT_MD = 1200
